import { z } from 'zod/v4';

export const GetImpactAreasHierarchyParamsSchema = z.object({
  sectionId: z.string().min(1),
});

export type GetImpactAreasHierarchyParams = z.infer<
  typeof GetImpactAreasHierarchyParamsSchema
>;

export const ImpactAreaSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  sectionId: z.string().min(1),
  parentId: z.string().nullable(),
  isParent: z.number().nullable(),
  level: z.number().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type ImpactArea = z.infer<typeof ImpactAreaSchema>;

export const ImpactAreasHierarchyResponseSchema = z.array(ImpactAreaSchema);

export type ImpactAreasHierarchyResponse = z.infer<
  typeof ImpactAreasHierarchyResponseSchema
>;
